<template>
  <div class = "st-table">
    <el-tabs v-model="leaveActiveTab" type="border-card">
      <el-tab-pane label="Leave Request" name="leave">
        <el-card shadow="always">
          <el-form :model="formItem" label-position="left" label-width="145px" label-colon class="leave-request-form">
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Date" :span="12">
                  <el-date-picker
                    class="leave-request-control-width"
                    type="dates"
                    v-model="formItem.days"
                    :picker-options="{
                          disabledDate: (time) =>
                            time.getTime() <
                            new Date(new Date().setHours(0, 0, 0, 0))
                        }"
                    @change="formItem.days = $event"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Type" :span="12">
                  <el-select
                    v-model="formItem.category"
                    class="leave-request-control-width"
                    filterable
                    remote
                    clearable
                  >
                    <el-option
                      v-for="(option, index) in options.types"
                      :value="option.value"
                      :label="option.label"
                      :key="index"
                    >{{options.label}}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Time(Hrs)" :span="12">
                  <el-input-number
                    v-if="formItem.category === 'BEREAVEMENT'"
                    :max="3"
                    :min="1"
                    :step="1"
                    step-strictly
                    v-model="formItem.time"
                  >
                  </el-input-number>
                  <el-input-number
                    v-else
                    :max="8"
                    :min="1"
                    :step="1"
                    step-strictly
                    v-model="formItem.time"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Notes" :span="12">
                  <el-input
                    class="leave-request-control-width"
                    v-model="formItem.comment"
                    placeholder="Please Input"
                    clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16" class="leave-tab-submit-row">
              <el-col :span="6">
                <el-form-item label-width="0">
                  <el-button
                    type="primary"
                    @click="onSubmit"
                    v-loading.fullscreen.lock="loading"
                  >
                    Submit
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Admin" name="admin" v-if="this.userName==='rbi'" >
        <el-card shadow="always">
          <el-form :model="formItem" label-position="left" label-width="145px" label-colon class="admin-leave-form">
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Name" :span="12">
                  <el-select
                    v-model="formItem.user"
                    class="admin-leave-name-select"
                    filterable
                    clearable
                    :loading="loading"
                  >
                    <el-option
                      v-for="(option) in options.users"
                      :value="option.value"
                      :key="option.label"
                      :label="option.label"
                    >
                      {{option.label}}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Date" :span="12">
                  <el-date-picker
                    class="admin-leave-control-width"
                    type="dates"
                    v-model="formItem.days"
                    :picker-options="pickerOptions"
                    @change="formItem.days = $event"
                    value-format="yyyy-MM-dd"
                    :options="disable_date"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Type" :span="12">
                  <el-select v-model="formItem.category"
                             class="admin-leave-control-width"
                             filterable remote clearable>
                    <el-option
                      v-for="(option, index) in options.types"
                      :value="option.value"
                      :key="index"
                    >{{options.label}}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Time(Hrs)" :span="12">
                  <el-input-number
                    v-if="formItem.category === 'BEREAVEMENT'"
                    :max="3"
                    :min="1"
                    :step="1"
                    step-strictly
                    v-model="formItem.time"
                  >
                  </el-input-number>
                  <el-input-number
                    v-else
                    :max="8"
                    :min="1"
                    :step="1"
                    step-strictly
                    v-model="formItem.time"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Notes" :span="12">
                  <el-input
                    class="admin-leave-control-width"
                    v-model="formItem.comment"
                    placeholder="Please Input"
                    clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16" class="leave-tab-submit-row">
              <el-col :span="6">
                <el-form-item label-width="0">
                  <el-button
                    type="primary"
                    @click="adminSubmit"
                    v-loading.fullscreen.lock="loading"
                  >
                    Submit
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>

      </el-tab-pane>
    </el-tabs>

    <el-card
      class="leave-history-wrap"
      shadow="always"
      title="Weekly Report"
      style="width: 100%"
    >
      <el-alert
        v-if="leaveActiveTab === 'admin' && isLeaveAdmin && !formItem.user"
        title="Select a person above to view their leave records for this year."
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 12px"
      />
      <el-form>
        <el-table
          :data="leaveHistoryList"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="fullName"
            label="Name"
          />
          <el-table-column
            prop="day"
            label="Date"
          />
          <el-table-column
            prop="category"
            label="Type"
          >
            <template slot-scope="scope">
              <el-select
                v-model="leaveHistoryPatchItem.category"
                filterable
                remote
                clearable
                v-if="leaveHistoryIsEdit === scope.$index"
              >
                <el-option
                  v-for="(option, index) in options.types"
                  :value="option.value"
                  :label="option.label"
                  :key="index"
                >{{ option.label }}</el-option>
              </el-select>
              <span v-else>{{ scope.row.category }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="time"
            label="Period"
          >
            <template slot-scope="scope">
              <input
                v-if="leaveHistoryIsEdit === scope.$index"
                type="text"
                v-model="leaveHistoryPatchItem.time"
              >
              <span v-else>{{ scope.row.time }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="comment"
            label="Notes"
          >
            <template slot-scope="scope">
              <input
                v-if="leaveHistoryIsEdit === scope.$index"
                type="text"
                v-model="leaveHistoryPatchItem.comment"
              >
              <span v-else>{{ scope.row.comment }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Action"
            width="180"
          >
            <template slot-scope="scope">
              <div v-if="leaveHistoryIsEdit === scope.$index">
                <el-button
                  size="small"
                  type="primary"
                  plain
                  @click="saveLeaveHistory(scope.$index, scope.row)"
                >
                  Save
                </el-button>
                <el-button
                  size="small"
                  plain
                  @click="leaveHistoryIsEdit = -99"
                >
                  Cancel
                </el-button>
              </div>
              <div v-else>
                <el-button
                  type="primary"
                  size="small"
                  style="margin-right: 5px"
                  @click="handleLeaveHistoryEdit(scope.$index, scope.row)"
                >
                  Edit
                </el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click="deleteLeaveHistory(scope.$index, scope.row)"
                >
                  Delete
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="leaveHistoryQuery.currentPage"
          :page-sizes="[10, 20, 50]"
          :total="leaveHistoryQuery.totalPage"
          :page-size.sync="leaveHistoryQuery.pageSize"
          prev-text="Previous"
          next-text="Next"
          style="margin-top: 4px"
          show-total
          @size-change="handleLeaveHistorySizeChange"
          @current-change="handleLeaveHistoryPageChange"
        />
      </el-form>
    </el-card>
  </div>
</template>

<script>
import attendanceApi from'@/api/attendance.js';
import userApi from '@/api/user.js'

export default {
  name: "attRequest",
  data() {
    return {

      pickerOptions: {
        disabledDate(time) {
          const disabledDay = time.getDay()
          return (
            disabledDay === 0 ||
            disabledDay === 6
          )
        },
      },
      formItem: {
        user:"",
        days: [],
        category: '',
        time: 1,
        comment: '',
      },
      options: {
        users: [],
        types: [
          {
            value: 'Time_Off_Request_PTO',
            label: 'Time Off Request – PTO',
          },
          {
            value: 'Time_Off_Request_UPTO',
            label: 'Time Off Request – UPTO',
          },
          {
            value: 'Jury_Duty',
            label: 'Jury Duty',
          },
          {
            value: 'BEREAVEMENT',
            label: 'BEREAVEMENT',
          },
        ],
      },
      loading: false,
      leaveHistoryList: [],
      leaveHistoryQuery: {
        currentPage: 1,
        pageSize: 10,
        totalPage: 0,
      },
      leaveHistoryPatchItem: {
        id: '',
        category: '',
        time: '',
        comment: '',
      },
      leaveHistoryIsEdit: -99,
      leaveActiveTab: 'leave',
    }

  },
  methods:{
    fetchLeaveHistory() {
      if (!this.leaveTableUserId) {
        this.leaveHistoryList = []
        this.leaveHistoryQuery.totalPage = 0
        return
      }
      const y = new Date().getFullYear()
      const para = {
        date_from: `${y}-01-01`,
        date_to: `${y}-12-31`,
        user_id: this.leaveTableUserId,
        offset: this.leaveHistoryQuery.pageSize * (this.leaveHistoryQuery.currentPage - 1),
        limit: this.leaveHistoryQuery.pageSize,
      }
      attendanceApi.getAttList(para).then((res) => {
        this.leaveHistoryList = res.data.data
        this.leaveHistoryQuery.totalPage = res.data.total
      })
    },
    handleLeaveHistoryEdit(index, row) {
      this.leaveHistoryPatchItem.category = row.category
      this.leaveHistoryPatchItem.time = row.time
      this.leaveHistoryPatchItem.comment = row.comment
      this.leaveHistoryIsEdit = index
    },
    handleLeaveHistorySizeChange() {
      this.fetchLeaveHistory()
    },
    handleLeaveHistoryPageChange() {
      this.fetchLeaveHistory()
    },
    saveLeaveHistory(_index, row) {
      const para = { id: row.id }
      const data = { ...this.leaveHistoryPatchItem }
      data.description = this.leaveHistoryPatchItem.category
      data.time = this.leaveHistoryPatchItem.time
      data.percentage = this.leaveHistoryPatchItem.percentage
      attendanceApi.patchAtt(para, data).then((resp) => {
        this.$message.success({
          message: resp.msg,
          type: 'success',
        })
        this.fetchLeaveHistory()
      })
      this.leaveHistoryIsEdit = -99
    },
    deleteLeaveHistory(index, row) {
      this.$confirm('Delete the attendance, continue?', 'Tips', {
        type: 'warning',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then(() => {
        const para = { id: row.id }
        attendanceApi.deleteAtt(para).then((resp) => {
          this.$message.success({
            message: resp.msg,
            type: 'success',
          })
          this.fetchLeaveHistory()
        })
      })
    },
    validateLeaveForm(requireUser) {
      if (requireUser && !this.formItem.user) {
        this.$message.warning('Please select an employee.')
        return false
      }
      if (!this.formItem.days || !this.formItem.days.length) {
        this.$message.warning('Please select at least one date.')
        return false
      }
      if (!this.formItem.category) {
        this.$message.warning('Please select a leave type.')
        return false
      }
      if (!this.formItem.time) {
        this.$message.warning('Please specify leave hours.')
        return false
      }
      return true
    },
    onSubmit() {
      if (!this.validateLeaveForm(false)) {
        return
      }
      this.loading = true
      let payload = this.formItem
      payload['category'] = this.formItem.category
      payload['time'] = this.formItem.time
      payload['comment'] = this.formItem.comment
      payload['days'] = this.formItem.days
      attendanceApi.createAtt(payload).then(
        () => {
          this.loading = false
          this.fetchLeaveHistory()
      }
      ).catch(err =>{
          console.log(err)
          this.loading = false
        }
      )
      //this.loading = false
    },
    adminSubmit() {
      if (!this.validateLeaveForm(true)) {
        return
      }
      this.loading = true
      let payload = this.formItem
      payload['user_id'] = this.formItem.user
      payload['category'] = this.formItem.category
      payload['time'] = this.formItem.time
      payload['comment'] = this.formItem.comment
      payload['days'] = this.formItem.days
      attendanceApi.adminCreate(payload).then(
        () => {
          this.loading = false
          this.fetchLeaveHistory()
        }
      ).catch(err =>{
          console.log(err)
          this.loading = false
        }
      )
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.options.users.push({value: user.id, label: user["fullName"]})
        }
      })
    },

  },
  computed: {
    userId() {
      return this.$store.getters.userid;
    },
    userName() {
      return this.$store.getters.userName;
    },
    userRole() {
      return this.$store.getters.userRole;
    },
    isLeaveAdmin() {
      return this.userName === 'rbi';
    },
    leaveTableUserId() {
      if (this.leaveActiveTab === 'admin' && this.isLeaveAdmin) {
        return this.formItem.user || null;
      }
      return this.userId || null;
    },
  },
  watch: {
    leaveActiveTab() {
      this.leaveHistoryIsEdit = -99;
      this.leaveHistoryQuery.currentPage = 1;
      this.fetchLeaveHistory();
    },
    'formItem.user'() {
      if (!this.isLeaveAdmin || this.leaveActiveTab !== 'admin') {
        return;
      }
      this.leaveHistoryQuery.currentPage = 1;
      this.fetchLeaveHistory();
    },
  },
  mounted() {
    this.getSelects();
    this.fetchLeaveHistory();
  },
}
</script>



<style lang="scss" scoped>
.st-table {
  padding:10px
}

.admin-leave-form .admin-leave-name-select {
  width: 280px;
}

.admin-leave-form .admin-leave-control-width {
  width: 280px;
}

.leave-request-form .leave-request-control-width {
  width: 280px;
}

.leave-tab-submit-row {
  margin-top: 5px;
}

.leave-tab-submit-row ::v-deep .el-form-item {
  margin-bottom: 0;
}

.leave-tab-submit-row ::v-deep .el-form-item__content {
  margin-left: 0 !important;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.leave-history-wrap {
  margin-top: 20px;
}

</style>
